import { render } from "./title-block.vue?vue&type=template&id=3881bed6&ts=true"
import script from "./title-block.ts?vue&type=script&lang=ts&external"
export * from "./title-block.ts?vue&type=script&lang=ts&external"

import "./title-block.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__